import PubSub from "underpub-js";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
gsap.registerPlugin(ScrollToPlugin);

/**
 * Sitewide
 */
var Sitewide = function(){

};

/**
 * Init
 */
Sitewide.prototype.init = function(){

  var self = this;

  this.initEvents();

};

/**
 * Init'ing our global events, many of which we publish
 */
Sitewide.prototype.initEvents = function(){

    //
    // Resizing (at the start)
    //
    var windowThrottled = _.throttle(function(e){
        PubSub.publish('resize');
    }, 0, {trailing: false});
    window.addEventListener("resize", windowThrottled, false);

    //
    // Resized Event (at the end)
    //
    var windowResizeDebounce = _.debounce(function(e) {
        PubSub.publish('resized');
    }, 400);
    window.addEventListener("resize", windowResizeDebounce, false);

    // smooth scroll anchor links
    $(document).on('click', 'a[href^="#"]', function (event) {

        event.preventDefault();
        gsap.to( $(window), { duration: 1.1, ease: 'back.out(1.3)', scrollTo: $($.attr(this, 'href')).offset().top } );

    });

};

export default Sitewide;
